import POST_COMPONENT_TYPE from '../postComponentType';
import WeightLossMedicationHero from '../../../assets/images/weight-loss-medication-hero-section.png';
import { IconType } from '../../../components/BannerWithList';
import { BackgroundColor } from '../../../components/BannerWithTextAndDescription';

const weightLossMedicationData = {
  key: 'weight-loss-medication',
  sectionList: [
    {
      type: POST_COMPONENT_TYPE.title,
      text: 'learnMoreContent.weight-loss-medication.name'
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithTextBox,
      image: WeightLossMedicationHero,
      text: 'learnMoreContent.weight-loss-medication.banner.text'
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithList,
      title: 'learnMoreContent.weight-loss-medication.howItWorks.title',
      iconType: IconType.SUCCESS,
      listGroups: [
        {
          items: [
            {
              text:
                'learnMoreContent.weight-loss-medication.howItWorks.listItem1',
              type: 'text'
            },
            {
              text:
                'learnMoreContent.weight-loss-medication.howItWorks.listItem2',
              type: 'text'
            },
            {
              text:
                'learnMoreContent.weight-loss-medication.howItWorks.listItem3',
              type: 'text'
            },
            {
              text:
                'learnMoreContent.weight-loss-medication.howItWorks.listItem4',
              type: 'text'
            }
          ]
        }
      ]
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithTextAndDescription,
      title: 'learnMoreContent.weight-loss-medication.limitations.title',
      description: {
        text: 'learnMoreContent.weight-loss-medication.limitations.description',
        type: 'textWithLink',
        link: 'https://www.lealy.health/begleitprogramm-zur-abnehmspritze',
        linkText: 'learnMoreContent.weight-loss-medication.limitations.linkText'
      }
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithList,
      title: 'learnMoreContent.weight-loss-medication.availability.title',
      iconType: IconType.SUCCESS,
      listGroups: [
        {
          title:
            'learnMoreContent.weight-loss-medication.availability.listGroup1.title',
          items: [
            {
              text:
                'learnMoreContent.weight-loss-medication.availability.listGroup1.listItem1',
              type: 'text'
            },
            {
              text:
                'learnMoreContent.weight-loss-medication.availability.listGroup1.listItem2',
              type: 'text'
            },
            {
              text:
                'learnMoreContent.weight-loss-medication.availability.listGroup1.listItem3',
              type: 'text'
            }
          ]
        }
      ],
      note: 'learnMoreContent.weight-loss-medication.availability.note'
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithList,
      title: 'learnMoreContent.weight-loss-medication.eligibility.title',
      iconType: IconType.SUCCESS,
      listGroups: [
        {
          title:
            'learnMoreContent.weight-loss-medication.eligibility.listGroup1.title',
          items: [
            {
              text:
                'learnMoreContent.weight-loss-medication.eligibility.listGroup1.listItem1',
              type: 'text'
            },
            {
              text:
                'learnMoreContent.weight-loss-medication.eligibility.listGroup1.listItem2',
              type: 'text'
            },
            {
              text:
                'learnMoreContent.weight-loss-medication.eligibility.listGroup1.listItem3',
              type: 'text'
            }
          ]
        }
      ],
      note: 'learnMoreContent.weight-loss-medication.eligibility.note'
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithTextAndDescription,
      title: 'learnMoreContent.weight-loss-medication.cost.title',
      description: {
        text: 'learnMoreContent.weight-loss-medication.cost.description',
        type: 'text'
      },
      backgroundColor: BackgroundColor.GREEN
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithList,
      title: 'learnMoreContent.weight-loss-medication.isCovered.title',
      iconType: IconType.SUCCESS,
      listGroups: [
        {
          title:
            'learnMoreContent.weight-loss-medication.isCovered.listGroup1.title',
          items: [
            {
              text:
                'learnMoreContent.weight-loss-medication.isCovered.listGroup1.listItem1',
              type: 'text'
            },
            {
              text:
                'learnMoreContent.weight-loss-medication.isCovered.listGroup1.listItem2',
              type: 'text'
            },
            {
              text:
                'learnMoreContent.weight-loss-medication.isCovered.listGroup1.listItem3',
              type: 'text'
            },
            {
              text:
                'learnMoreContent.weight-loss-medication.isCovered.listGroup1.listItem4',
              type: 'text',
              subItems: [
                {
                  text:
                    'learnMoreContent.weight-loss-medication.isCovered.listGroup1.listItem4.subItem1',
                  type: 'text'
                },
                {
                  text:
                    'learnMoreContent.weight-loss-medication.isCovered.listGroup1.listItem4.subItem2',
                  type: 'text'
                },
                {
                  text:
                    'learnMoreContent.weight-loss-medication.isCovered.listGroup1.listItem4.subItem3',
                  type: 'text'
                },
                {
                  text:
                    'learnMoreContent.weight-loss-medication.isCovered.listGroup1.listItem4.subItem4',
                  type: 'text'
                }
              ]
            }
          ]
        }
      ],
      note: 'learnMoreContent.weight-loss-medication.isCovered.note'
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithList,
      title: 'learnMoreContent.weight-loss-medication.risks.title',
      iconType: IconType.WARNING,
      listGroups: [
        {
          title:
            'learnMoreContent.weight-loss-medication.risks.listGroup1.title',
          items: [
            {
              text:
                'learnMoreContent.weight-loss-medication.risks.listGroup1.listItem1',
              type: 'text'
            },
            {
              text:
                'learnMoreContent.weight-loss-medication.risks.listGroup1.listItem2',
              type: 'text'
            },
            {
              text:
                'learnMoreContent.weight-loss-medication.risks.listGroup1.listItem3',
              type: 'text'
            },
            {
              text:
                'learnMoreContent.weight-loss-medication.risks.listGroup1.listItem4',
              type: 'text'
            }
          ]
        }
      ],
      note: 'learnMoreContent.weight-loss-medication.risks.note'
    }
  ]
};

export default weightLossMedicationData;